import App from "./App.vue";
import Ad from "@/components/Ads/Ad.vue";
import Icon from "@/components/Globals/Icon.vue";
import AspectRatio from "@/components/Globals/AspectRatio.vue";
import ModalVideo from "@/components/Globals/ModalVideo.vue";
import VideoBackground from "@/components/Globals/VideoBackground";
import SectionBackground from "@/components/Globals/SectionBackground";

import Vue from "vue";
import router from "./router";
import "fullpage.js/vendors/scrolloverflow";
import VueFullPage from "vue-fullpage.js";
import DomPortal from "vue-dom-portal";
import VueMoment from "vue-moment";
import Vue2TouchEvents from "vue2-touch-events";
import normal_scroll_section_directive from "@/directives/normal_scroll_section";
import fullpage_mixin from "@/mixins/fullpage";
import preventDesktop_mixin from "@/mixins/preventDesktop";
import moment from "moment";
import { sort_by } from "@/helpers.js";

Vue.use(VueFullPage);
Vue.use(DomPortal);
Vue.use(VueMoment);
Vue.use(Vue2TouchEvents);
Vue.prototype.moment = moment;
Vue.component("aspect-ratio", AspectRatio);
Vue.component("icon", Icon);
Vue.component("ad", Ad);
Vue.component("modal-video", ModalVideo);
Vue.component("video-background", VideoBackground);
Vue.component("section-background", SectionBackground);

Vue.directive("setNormalScroll", normal_scroll_section_directive);
Vue.mixin({
  methods: {
    goto: (url, new_tab) => {
      if (!new_tab) {
        window.location.href = url;
        return;
      }
      window.open(url, "_blank");
      return;
    }
  }
});

Vue.mixin(fullpage_mixin);
Vue.mixin(preventDesktop_mixin);

new Vue({
  data: () => ({
    active_anchor: "home",

    data: null,

    loading_data: true,

    cumestats_individual: null,

    cumestats_overall: null,

    fullpage_ref: null,

    move_via_nav: false,

    global_sport_shortname:
      process.env.NODE_ENV === "production" || process.env.VUE_APP_CLONE
        ? window.global_sport_shortname
        : "mbball",
    year:
      process.env.NODE_ENV === "production" || process.env.VUE_APP_CLONE
        ? window.tournament_year
        : 2020,
    base_url_cdn: window.custom_cdn_url ? window.custom_cdn_url : ""
  }),

  computed: {
    final_four_location() {
      return this.data &&
        this.data.tournament_info &&
        this.data.tournament_info.location
        ? this.data.tournament_info.location
        : { abbrev: "", name: "" };
    },

    selection_day_text() {
      if (
        this.data &&
        this.data.tournament_info &&
        moment(this.data.tournament_info.selection_date).isValid()
      ) {
        const week_day = moment(
          this.data.tournament_info.selection_date
        ).isoWeekday();
        //monday || sunday
        if (week_day === 1 || week_day === 7) {
          return moment(this.data.tournament_info.selection_date).format(
            "dddd"
          );
        }
      }
      return "Show";
    },

    games_with_data() {
      // map the round to list of games with round property
      let rounds_with_data = [];
      Object.keys(this.data.tournament_section).forEach(key => {
        if (this.data.tournament_section[key].game) {
          rounds_with_data.push(this.data.tournament_section[key]);
        }
      });
      // sorting by rounds 68,64,32,16,8,4,2
      return rounds_with_data.sort((a, b) => b.round - a.round);
    },

    upcoming_game() {
      let upcoming_games = this.games_with_data.filter(
        round => !round.game.result || !round.game.result.status
      );

      if (upcoming_games && upcoming_games.length) {
        return upcoming_games[0];
      }

      return null;
    },

    past_games() {
      return this.games_with_data
        .filter(round => round.game.result && round.game.result.status)
        .slice()
        .reverse();
    },

    previous_game() {
      if (this.past_games.length === 0) {
        return null;
      }
      return this.past_games[0];
    },

    roster_with_stats() {
      if (!this.data || !this.cumestats_individual) {
        return [];
      }

      let roster_without_stats = this.data.roster.slice();
      let cumestats_without_roster = this.cumestats_individual.slice();

      let roster_combined = roster_without_stats.map(player => {
        let cumestats_index = cumestats_without_roster.findIndex(
          stats => parseInt(stats.player_roster_bio_id) === player.rp_id
        );
        let matched_cumestats = false;
        if (cumestats_index > -1) {
          matched_cumestats = cumestats_without_roster.splice(
            cumestats_index,
            1
          );
        }
        player.cumestats = matched_cumestats ? matched_cumestats[0] : null;
        return player;
      });

      return roster_combined;
    },

    navigation() {
      if (!this.$root.data) {
        return [];
      }

      let dynamic_nav = [];
      const _data = this.$root.data;

      // if(this.$root.render_check_on_basic_properties('selection_sunday_section')){
      dynamic_nav.push({
        title: "Selection " + this.selection_day_text,
        hash: "home",
        items: [],
        is_toggled: false
      });
      // }

      //game day
      if (this.$root.upcoming_game) {
        let gameday_nav_object = {
          title: "Gameday",
          hash: "gameday",
          items: [],
          is_toggled: false
        };
        dynamic_nav.push(gameday_nav_object);
      }

      //tournament run
      if (this.$root.past_games && this.$root.past_games.length) {
        let run_nav_object = {
          title: "Tournament Run",
          hash: "tournament-run",
          items: [],
          is_toggled: false
        };
        dynamic_nav.push(run_nav_object);
      }

      //reaction
      if (
        this.$root.render_check_on_basic_properties("reaction_section") &&
        _data.reaction_section
      ) {
        let reaction_nav_object = {
          title: "Team Reaction",
          hash: "reaction",
          items: [],
          is_toggled: false
        };
        dynamic_nav.push(reaction_nav_object);
      }

      //how we got here
      if (
        this.$root.render_check_on_basic_properties(
          "how_we_got_here_section"
        ) &&
        _data.how_we_got_here_section.games &&
        _data.how_we_got_here_section.games.length
      ) {
        let how_we_got_here_nav_object = {
          title: "How We Got Here",
          hash: "featured-games",
          is_toggled: false,
          items: [{ title: "Overall Recap", hash: 0 }]
        };

        _data.how_we_got_here_section.games.forEach((game, index) =>
          how_we_got_here_nav_object.items.push({
            title:
              (game.location_indicator === "H" ? "vs " : "at ") +
              game.opponent.title,
            hash: index + 1
          })
        );

        dynamic_nav.push(how_we_got_here_nav_object);
      }

      //galleries
      if (this.$root.render_gallery_section) {
        let galleries_nav_object = {
          title: "Photo Gallery",
          hash: "gallery",
          items: [],
          is_toggled: false
        };
        dynamic_nav.push(galleries_nav_object);
      }

      //social
      if (this.$root.render_social_section) {
        let social_nav_object = {
          title:
            "Social" +
            (_data.social_section.hashtag
              ? " #" + _data.social_section.hashtag
              : ""),
          hash: "social",
          items: [],
          is_toggled: false
        };
        dynamic_nav.push(social_nav_object);
      }

      return dynamic_nav;
    },

    sport_id() {
      if (
        this.data &&
        this.data.tournament_experience &&
        this.data.tournament_experience.sport_id
      ) {
        return this.data.tournament_experience.sport_id;
      }
      return 0;
    },

    continue_url() {
      let url = "/index.aspx";
      if (this.data && this.data.sport && this.data.sport.sport_shortname) {
        return url + "?path=" + this.data.sport.sport_shortname;
      }
      return url;
    },

    render_hero_section() {
      // if (!this.render_check_on_basic_properties('selection_sunday_section')) {
      //   return false;
      // }

      return true;
    },

    render_reaction_section() {
      if (!this.render_check_on_basic_properties("reaction_section")) {
        return false;
      }

      return true;
    },

    render_how_we_got_here_section() {
      if (!this.render_check_on_basic_properties("how_we_got_here_section")) {
        return false;
      }

      if (!this.$root.data.how_we_got_here_section.games.length) {
        return false;
      }

      return true;
    },

    render_gallery_section() {
      if (!this.render_check_on_basic_properties("galleries_section")) {
        return false;
      }

      if (!this.$root.data.galleries_section.galleries.length) {
        return false;
      }

      return true;
    },

    render_social_section() {
      if (!this.render_check_on_basic_properties("social_section")) {
        return false;
      }

      if (
        !this.$root.data.social_section ||
        (!this.$root.data.social_section.links.length &&
          !this.$root.data.social_section.hashtag)
      ) {
        return false;
      }

      return true;
    }
  },

  methods: {
    create_css_custom_props() {
      const create_mobile_background_value = value =>
        create_background_value(value, 1080, 1920);
      const create_background_value = (value, width, height) =>
        value
          ? create_background(value.url, width, height)
          : create_background("", width, height);
      const create_background = (value, width, height) => {
        width = width || 1920;
        height = height || 1080;
        return value
          ? `url('${this.absolutize_cdn(
              value
            )}?width=${width}&height=${height}&crop=true&s.alpha=0.05&bgcolor=black&format=jpg&quality=90')`
          : `url('https://s3.amazonaws.com/assets.sidearmsports.com/march_madness_2020/396696.jpg')`;
      }; 
      var styles = document.createElement("style");
      styles.innerHTML = `
        :root {
          --section-desktop-bg-navigation: ${create_background_value(
            this.data.navigation.background_image_desktop
          )};
          --section-mobile-bg-navigation: ${create_mobile_background_value(
            this.data.navigation.background_image_mobile ||
              this.data.navigation.background_image_desktop
          )};

          --section-desktop-bg-selection-sunday-results: ${create_background_value(
            this.data.selection_sunday_section.background_image_desktop
          )};
          --section-mobile-bg-selection-sunday-results: ${create_background_value(
            this.data.selection_sunday_section.background_image_mobile ||
              this.data.selection_sunday_section.background_image_desktop
          )};
          
          --section-desktop-bg-selection-sunday-reaction: ${create_background_value(
            this.data.reaction_section.background_image_desktop
          )};
          --section-mobile-bg-selection-sunday-reaction: ${create_mobile_background_value(
            this.data.reaction_section.background_image_mobile ||
              this.data.reaction_section.background_image_desktop
          )};

          --section-desktop-bg-selection-sunday-hero: ${create_background_value(
            this.data.selection_sunday_section.background_image_desktop
          )};
          --section-mobile-bg-selection-sunday-hero: ${create_mobile_background_value(
            this.data.selection_sunday_section.background_image_mobile ||
              this.data.selection_sunday_section.background_image_desktop
          )};
          --section-desktop-bg-selection-sunday-hero-win: ${
            this.previous_game &&
            this.previous_game.game &&
            this.previous_game.game.story &&
            this.previous_game.game.story.image &&
            this.previous_game.game.story.image.url
              ? create_background(this.previous_game.game.story.image.url)
              : create_background_value(
                  this.data.selection_sunday_section.background_image_desktop
                )
          };

          --section-desktop-bg-how-we-got-here: ${create_background_value(
            this.data.how_we_got_here_section.background_image_desktop
          )};
          --section-mobile-bg-how-we-got-here: ${create_mobile_background_value(
            this.data.how_we_got_here_section.background_image_mobile ||
              this.data.how_we_got_here_section.background_image_desktop
          )};

          --section-desktop-bg-social: ${create_background_value(
            this.data.social_section.background_image_desktop
          )};
          --section-mobile-bg-social: ${create_mobile_background_value(
            this.data.social_section.background_image_mobile ||
              this.data.social_section.background_image_desktop
          )};
        }
      `;

      document.head.appendChild(styles);
    },

    get_data() {
      this.get_tournament_experience()
        .then(response => {
          document.title = `Tournament ${this.year}`;
          if (response.school.name) {
            document.title = `Tournament ${this.year} - ${response.school.name}`;
          }
          return this.get_updated_games(response.tournament_section)
            .then(updated_games => {
              Object.keys(response.tournament_section).forEach(key => {
                const game = response.tournament_section[key].game;
                if (game) {
                  const matching_game = updated_games.find(
                    x => x.id === game.id
                  );
                  if (matching_game) {
                    response.tournament_section[key].game.date =
                      matching_game.date;
                    response.tournament_section[key].game.time =
                      matching_game.time;
                    response.tournament_section[key].game.tbd =
                      matching_game.tbd;
                    response.tournament_section[key].game.location_indicator =
                      matching_game.location_indicator;
                    response.tournament_section[key].game.location =
                      matching_game.location;
                    if (!response.tournament_section[key].game.media) {
                      response.tournament_section[key].game.media = {};
                    }
                    if (matching_game.media) {
                      response.tournament_section[key].game.media.audio =
                        matching_game.media.audio;
                      response.tournament_section[key].game.media.audio_text =
                        matching_game.media.audio_text;
                      response.tournament_section[key].game.media.tv =
                        matching_game.media.tv;
                      response.tournament_section[key].game.media.tv_image =
                        matching_game.media.tv_image;
                      response.tournament_section[
                        key
                      ].game.media.tv_image_link =
                        matching_game.media.tv_image_link;
                      response.tournament_section[key].game.media.video =
                        matching_game.media.video;
                      response.tournament_section[key].game.media.video_text =
                        matching_game.media.video_text;
                      response.tournament_section[key].game.media.radio =
                        matching_game.media.radio;
                      response.tournament_section[key].game.media.stats =
                        matching_game.media.stats;
                      response.tournament_section[key].game.media.tickets =
                        matching_game.media.tickets;
                      response.tournament_section[key].game.media.program =
                        matching_game.media.program;
                      response.tournament_section[key].game.media.program_text =
                        matching_game.media.program_text;
                      response.tournament_section[key].game.media.gamefiles =
                        matching_game.media.gamefiles;
                    }

                    if (matching_game.opponent && matching_game.opponent.id) {
                      if (!response.tournament_section[key].game.opponent) {
                        response.tournament_section[key].game.opponent = {};
                      }
                      response.tournament_section[key].game.opponent.seed =
                        matching_game.opponent.prefix === null
                          ? ""
                          : matching_game.opponent.prefix.replace(/\D/g, "");
                      response.tournament_section[
                        key
                      ].game.opponent.title = matching_game.opponent.name.trim();
                    }
                    if (matching_game.result) {
                      response.tournament_section[key].game.result.status =
                        matching_game.result.status;
                      response.tournament_section[key].game.result.team_score =
                        matching_game.result.team_score;
                      response.tournament_section[
                        key
                      ].game.result.opponent_score =
                        matching_game.result.opponent_score;
                      response.tournament_section[key].game.result.boxscore =
                        matching_game.result.boxscore;
                      response.tournament_section[key].game.bid =
                        matching_game.result.bid;
                      try {
                        response.tournament_section[
                          key
                        ].game.result.result_json = JSON.stringify(
                          matching_game.result.line_scores
                        );
                      } catch (err) {}
                    } else {
                      matching_game.result = {};
                    }

                    // issue in components.cs - 2853 with getting the story image, dont update for now
                    // if (matching_game.story && matching_game.story.id) {
                    //   if (!response.tournament_section[key].game.story) {
                    //     response.tournament_section[key].game.story = {};
                    //   }
                    //   response.tournament_section[key].game.story.headline =
                    //     matching_game.story.title;
                    //   response.tournament_section[key].game.story.url =
                    //     matching_game.story.url;
                    //   if (!response.tournament_section[key].game.story.image) {
                    //     response.tournament_section[key].game.story.image = {};
                    //   }
                    //   response.tournament_section[key].game.story.image.url =
                    //     matching_game.story.image_source;
                    // }
                  }
                }
              });

              return response;
            })
            .then(response => {
              console.log("Tournament", response);
              this.data = response;
              this.create_css_custom_props();
              // this.$set(this, "data", response);
              this.$nextTick(() => {
                this.loading_data = false;
              });
            });
        })
        .catch(error => {
          console.warn(error);
        });
    },

    get_tournament_experience() {
      const data_url =
        process.env.NODE_ENV === "production" || process.env.VUE_APP_CLONE
          ? `${window.s3_bucket}/march_madness/${this.year}/${this.global_sport_shortname}/data_${window.data_timestamp}.json`
          : `https://s3.amazonaws.com/sidearm.sites/march_madness_2020.sidearmsports.com/march_madness_2020/${this.global_sport_shortname}/data.json`;

      return fetch(data_url)
        .then(response => response.json())
        .then(response => {
          if (response) {
            if (!response.team.first_four) {
              response.tournament_section.r68.game = null;
            }
            return response;
          }
        })
        .catch(error => {
          console.warn(error);
        });
    },

    get_updated_games(rounds) {
      let promises = [];
      Object.keys(rounds).forEach(key => {
        const game = rounds[key].game;
        if (game) {
          promises.push(
            fetch(
              `/services/adaptive_components.ashx?type=scoreboard&extra={game_id:${game.id}}&sport_id=0&count=1`
            ).then(response => response.json())
          );
        }
      });
      return Promise.all(promises).then(responses => {
        const games = responses.flat(1);

        return games.sort(sort_by("game_utc"));
      });
    },

    get_cumestats_individual() {
      if (process.env.NODE_ENV !== "production" && !process.env.VUE_APP_CLONE) {
        const stats = require("@/assets/data/cumestats_individual.json");
        this.cumestats_individual = stats.combined_individual_stats;
        return;
      }
      fetch(
        `/services/cumestats.ashx?global_sport_shortname=${
          this.global_sport_shortname
        }&year=${this.$root.year -
          1}&projection={combined_team_stats.combined_individual_stats}`
      )
        .then(response => response.json())
        .then(response => {
          if (response && response.combined_individual_stats) {
            this.cumestats_individual = response.combined_individual_stats;
          }
        });
    },

    get_cumestats_overall() {
      if (process.env.NODE_ENV !== "production" && !process.env.VUE_APP_CLONE) {
        const stats = require("@/assets/data/cumestats_overall.json");
        this.cumestats_overall = stats.overall_team_stats;
        return;
      }
      fetch(
        `/services/cumestats.ashx?global_sport_shortname=${
          this.global_sport_shortname
        }&year=${this.$root.year - 1}&projection={overall_team_stats}`
      )
        .then(response => response.json())
        .then(response => {
          if (response && response.overall_team_stats) {
            this.cumestats_overall = response.overall_team_stats;
          }
        });
    },

    render_check_on_basic_properties(section_key) {
      if (!this.$root.data) {
        return false;
      }

      const section = this.$root.data[section_key];

      if (section.active === false) {
        return false;
      }

      if (
        !section.title &&
        !section.sub_title &&
        !section.background_color &&
        !section.background_image_desktop &&
        !section.background_image_mobile &&
        !section.background_video.id
      ) {
        return false;
      }

      return true;
    },

    shorten_name(name) {
      if (!name) {
        return name;
      }
      let result = name.replace("College of", "");
      result = result.replace("College", "");
      result = result.replace("University of", "");
      result = result.replace("University", "");
      result = result.replace("Athletics", "");
      result = result.trim();
      return result;
    },
    absolutize_cdn(url) {
      if (
        !url ||
        !this.base_url_cdn ||
        url.indexOf("http") === 0 ||
        url.indexOf("//") === 0
      ) {
        if (url.indexOf("http") !== 0 && url.indexOf("//") !== 0) {
          return `${window.location.origin}${url}`;
        }
        return url;
      }
      return `${this.base_url_cdn}${url}`;
    },
    school_logo(width, height) {
      let logo = "/images/logos/site/site.png";
      if (
        this.$root.data &&
        this.$root.data.logos &&
        this.$root.data.logos.logo &&
        this.$root.data.logos.logo.url
      ) {
        logo = this.$root.data.logos.logo.url;
      }
      let qs_params = {};
      if (width) {
        qs_params.width = width;
      }
      if (height) {
        qs_params.height = height;
      }
      logo = logo.split("?")[0];
      const qs = Object.keys(qs_params)
        .map(key => `${key}=${qs_params[key]}`)
        .join("&");
      if (qs) {
        logo = `${logo}?${qs}`;
      }

      return this.absolutize_cdn(logo);
    }
  },

  created() {
    this.get_data();
    this.get_cumestats_individual();
    this.get_cumestats_overall();
  },

  router,
  render: h => h(App)
}).$mount("#app");

if (process.env.NODE_ENV !== "production" && !process.env.VUE_APP_CLONE) {
  const style = document.createElement("style");
  style.innerHTML = `
		:root {
			--primary-background: 	#1C453B;
			--primary-text: 		    #FFFFFF;
			--secondary-background: #D9D9DB;
			--secondary-text: 	  	#1C453B;
			--safe-text-on-white: 	#000000;
			--safe-text-on-black: 	#FFFFff;
		}
	`;
  document.head.appendChild(style);
}
